<template>

    <v-card class="theme-card kpi-trend">
        <v-container>
            <v-row 
                class="my-2"
                :class="{
                    'my-0 mx-2' : $vuetify.breakpoint.md
                }"
            >
                <v-col cols="4" md="6" xl="4" 
                    class="text-center"
                >
                    <div class='icon-container' :class="{
                            'icon-green' : color === 'green',
                            'icon-orange' : color === 'orange',
                            'icon-yellow' : color === 'yellow'
                        }">
                        <v-icon class="material-icons-outlined">{{icon}}</v-icon>
                    </div>
                </v-col>
                <v-col cols="8" md="6" xl="8" 
                    class="p-relative"
                 
                >
                    <div class="text size-small color-black-alt-lighten-1">{{label}}</div>
                    <div class="text size-large color-black-base">{{value}}</div>
                    <div v-if="showTrend" class="trend-icon"
                        :class="{
                            'icon-green' : color === 'green',
                            'icon-orange' : color === 'orange',
                            'icon-yellow' : color === 'yellow'
                        }">
                        <v-icon v-if="trend === 'up'" small>arrow_upward</v-icon>
                        <v-icon v-if="trend === 'down'" small>arrow_downward</v-icon>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card>

</template>

<script type="text/javascript">

    export default {
        name: 'kpi-trend',
        components: {

        },
        props : {
            color : {
                type : String,
                default : 'green'
            },
            trend : {
                type : String,
                default : 'up'
            },
            label : {
                type : String,
                default : ''
            },
            value : {
                type : [Number,String]
            },
            icon : {
                type : String,
                default : 'user'
            }
        },
        data () {
            return {
                
            }
        },
        computed : {
            showTrend () {
                return this.trend !== 'even';
            }
        },
        created () {
            
        },
        methods : {
            
        }
    }

</script>

<style lang="scss">
    
    .kpi-trend {

        .trend-icon {
            position : absolute;
            bottom : 20px;
            right : 30px;
            &.icon-green {
                i {
                    color : $green-lighten-1;
                    opacity : 0.8;
                }
            }
            &.icon-orange {
                i {
                    color : $orange-lighten-1;
                    opacity : 0.8;
                }
            }
            &.icon-yellow {
                i {
                    color : $orange-lighten-1;
                    opacity : 0.5;
                }
            }
        }

        .icon-container {
            display: inline-block;
            width : 72px;
            height : 72px;
            text-align : center;
            border-radius : 50%;

            i {
                font-size : 54px;
                padding-top: 10px;
            }

            &.icon-green {
                background-color : $green-lighten-1;
                opacity : 0.8;
                i {
                    color : white;
                }
            }
            &.icon-orange {
                background-color : $orange-lighten-1;
                opacity : 0.8;
                i {
                    color : white;
                }
            }
            &.icon-yellow {
                background-color : $orange-lighten-1;
                opacity : 0.5;
                i {
                    color : white;
                }
            }
        }
    }

</style>
